import React, { Component } from 'react';
import {Button, Col} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import Icon from '../../../../components/Icon';
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.factor) {
            const { factor } = this.props;

            this.state = {
                country: factor.country,
                factor: factor.factor,
                update: true
            };
        }
        else this.state = { country: '',  factor: '' };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <SelectWrap
                        values={countriesOptions}
                        label="Country:"
                        name="country"
                        onChange={this.handleFieldChange}
                        value={this.state.country}
                    />
                    <FieldGroup
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        required
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCountry/components/Form/index.js